import React, { useContext } from 'react';
import { AppContext } from '../../App';
import { Newspaper, ExternalLink, Clock } from 'lucide-react';

const NewsSection = () => {
  const { dashboardData } = useContext(AppContext);
  
  if (!dashboardData) return null;
  
  const { news } = dashboardData;

  const getCategoryColor = (category) => {
    const colors = {
      'EV Market': 'bg-[#22C55E]/20 text-[#22C55E]',
      'Market Trends': 'bg-[#3B82F6]/20 text-[#3B82F6]',
      'Sales Rankings': 'bg-[#F97316]/20 text-[#F97316]',
      'Policy': 'bg-[#A855F7]/20 text-[#A855F7]',
      'Pricing': 'bg-[#EC4899]/20 text-[#EC4899]',
      'Service': 'bg-[#EF4444]/20 text-[#EF4444]',
      'Digital Trends': 'bg-[#06B6D4]/20 text-[#06B6D4]',
      'Regional': 'bg-[#84CC16]/20 text-[#84CC16]'
    };
    return colors[category] || 'bg-[#A1A1AA]/20 text-[#A1A1AA]';
  };

  const formatTimeAgo = (timestamp) => {
    const date = new Date(timestamp);
    const now = new Date();
    const diff = Math.floor((now - date) / 1000 / 60 / 60);
    
    if (diff < 1) return 'Just now';
    if (diff < 24) return `${diff}h ago`;
    if (diff < 48) return 'Yesterday';
    return `${Math.floor(diff / 24)}d ago`;
  };

  return (
    <div className="dashboard-card p-6" data-testid="news-section">
      <div className="flex items-center gap-3 mb-6">
        <div className="p-2 bg-[#3B82F6]/10 rounded-lg">
          <Newspaper className="w-5 h-5 text-[#3B82F6]" />
        </div>
        <div>
          <h3 className="text-lg font-bold text-white">Industry News</h3>
          <p className="text-sm text-[#A1A1AA]">Latest Canadian automotive updates</p>
        </div>
      </div>

      <div className="space-y-4">
        {news.slice(0, 5).map((item, index) => (
          <article 
            key={index}
            className="group cursor-pointer"
            data-testid={`news-${index}`}
          >
            <div className="flex items-start gap-4 p-3 rounded-lg hover:bg-[#27272A]/50 transition-colors">
              <div className="flex-1">
                <div className="flex items-center gap-2 mb-2">
                  <span className={`text-xs px-2 py-0.5 rounded ${getCategoryColor(item.category)}`}>
                    {item.category}
                  </span>
                  <span className="text-xs text-[#52525B]">{item.source}</span>
                </div>
                <h4 className="text-sm text-white font-medium mb-1 group-hover:text-[#3B82F6] transition-colors line-clamp-1">
                  {item.title}
                </h4>
                <p className="text-xs text-[#A1A1AA] line-clamp-2">{item.summary}</p>
              </div>
              <div className="flex flex-col items-end gap-2 shrink-0">
                <div className="flex items-center gap-1 text-xs text-[#52525B]">
                  <Clock className="w-3 h-3" />
                  {formatTimeAgo(item.timestamp)}
                </div>
                <ExternalLink className="w-4 h-4 text-[#52525B] group-hover:text-[#3B82F6] transition-colors" />
              </div>
            </div>
          </article>
        ))}
      </div>
    </div>
  );
};

export default NewsSection;
